export enum FileType {
  DOCX = "docx",
  PDF = "pdf",
}

export const COLOR = {
  RED: "#FF6B6B",
  TEAL: "#4ECDC4",
  BLUE: "#45B7D1",
  GREEN: "#96CEB4",
  YELLOW: "#FFEAA7",
  PINK: "#DDA0DD",
  GOLD: "#F7DC6F",
  LAVENDER: "#BB8FCE",
  LIGHT_BLUE: "#85C1E9",
  MINT: "#98D8C8",
};
